export default __webpack_public_path__ + "static/media/institute-5-min.c793495a.webp";